import React from 'react';
import { Quote, Star } from 'lucide-react';
export function TestimonialsHero() {
  const testimonials = [{
    initials: 'MP',
    quote: 'Organicé todo el mes en una tarde. Nunca más llego al gimnasio sin saber qué dar.',
    name: 'Marcela P.',
    location: 'Buenos Aires',
    role: 'Profesora de Gimnasia Artística en Club de Barrio',
    color: 'bg-blue-100 text-blue-700'
  }, {
    initials: 'LG',
    quote: 'Mis nenas de jardín mejoraron la postura corporal desde la primera semana con el Tomo 1.',
    name: 'Laura G.',
    location: 'Córdoba',
    role: 'Profesora de Gimnasia Artística en Academia Privada',
    color: 'bg-emerald-100 text-emerald-700'
  }, {
    initials: 'SR',
    quote: 'Antes tardaba 2 horas armando la clase. Ahora son 10 minutos.',
    name: 'Sebastián R.',
    location: 'Rosario',
    role: 'Profesor de Gimnasia Artística Independiente',
    color: 'bg-purple-100 text-purple-700'
  }];
  return <section className="py-16 bg-slate-50" data-id="element-275">
      <div className="max-w-6xl mx-auto px-4" data-id="element-276">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-277">
          {testimonials.map((t, i) => <div key={i} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 relative" data-id="element-278">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-gray-100 rotate-180" data-id="element-279" />

              <div className="flex gap-1 mb-4" data-id="element-280">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-281" />)}
              </div>

              <p className="text-gray-700 text-lg italic mb-6 relative z-10" data-id="element-282">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-283">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${t.color}`} data-id="element-284">
                  {t.initials}
                </div>
                <div data-id="element-285">
                  <p className="font-bold text-gray-900" data-id="element-286">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-287">{t.role}</p>
                  <p className="text-xs text-gray-400 mt-0.5" data-id="element-288">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}